/**
 * @name: ColorConstants
 * @author: Seeker
 * @date: 2025-06-09 09:37
 * @description：ColorConstants
 * @update: 2025-06-09 09:37
 */

const ColorConstants = {
    MINOR_ABN_COLOR:'#F1E83D',
    MAJOR_ABN_COLOR:'#DD4A39'
};

export default ColorConstants

